function scrollTo(e) {
	var target = jQuery(this).data('target');
	if (typeof(target) !== 'undefined' && target != '') {
		var top = jQuery(target).position().top;
		var position = top - jQuery('header').height() - 50;
		jQuery('html, body').stop().animate({ 'scrollTop': position }, 250, 'swing');
	}
}

function setScrollClass(status) {
	if (status) {
		$('html').addClass('down');
		$('html').removeClass('up');
	} else {
		$('html').addClass('up');
		$('html').removeClass('down');
	}
}

var lazyLoadInstance = null;

jQuery(document).ready(function() {
	
	lazyLoadInstance = new LazyLoad();

	$('#menu-btn').on ('click', function() {
		$('html').toggleClass('open-menu');
	});

	$('.scroll-to').on('click', scrollTo);

	$('a[href="#contact"]').on('click', function(e) {
		e.preventDefault();

		const modal = bootstrap.Modal.getOrCreateInstance(
			document.getElementById('contact')
		);

		modal.show();

		if ( $('html').hasClass('open-menu') ) {
			bootstrap.Collapse
				.getOrCreateInstance(document.getElementById('navigation'))
				.hide();
				
			$('html').removeClass('open-menu');
		}
	});
	
});

jQuery(window).on('load', function() {
	// Header height
	var navHeight = parseInt($('header').height());

	// Adds class 'scroll' when scrolled larger than the header height
	$(window).scroll(function() {
		var scroll = $(window).scrollTop();
		if (scroll > navHeight) {
			$('html').addClass('scroll');
		} else {
			$('html').removeClass('scroll');
		}
	});

	var lastScrollTop = 0;
	$(window).scroll(function(event){
		var st = $(this).scrollTop();
		if (st > lastScrollTop) {
			setTimeout('setScrollClass(true)', 250);
		} else {
			setTimeout('setScrollClass(false)', 250);
		}
		lastScrollTop = st;
	});
});